import * as THREE from "three";
import fragment from "./shader/fragment.glsl";
import vertex from "./shader/vertexParticles.glsl";
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import GUI from 'lil-gui';

export default class Sketch {
    constructor(options) {
        this.scene = new THREE.Scene();

        this.container = options.dom;
        this.width = this.container.offsetWidth;
        this.height = this.container.offsetHeight;
        this.renderer = new THREE.WebGLRenderer();
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.width, this.height);
        this.renderer.setClearColor(0x0F0F0F, 1);

        this.mouse = {x: 0, y: 0};

        document.addEventListener('mousemove', (event) => {
            this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        });

        this.container.appendChild(this.renderer.domElement);

        this.camera = new THREE.PerspectiveCamera(
            70,
            window.innerWidth / window.innerHeight,
            0.001,
            1000
        );
        this.camera.position.set(options.px, options.py, options.pz);
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableZoom = false;
        this.controls.enableRotate = false;
        this.controls.enablePan = false;
        this.controls.target.set(options.tx, options.ty, options.tz);
        this.controls.update()
        this.time = 0;

        this.isPlaying = true;

        this.addObjects();
        this.resize();
        this.render();
        this.setupResize();
        // this.settings();
    }

    settings() {
        this.gui = new GUI();

        // 添加摄像机位置控制
        const cameraFolder = this.gui.addFolder('摄像机位置');
        cameraFolder.add(this.camera.position, 'x', -10, 10).name('X 轴');
        cameraFolder.add(this.camera.position, 'y', -10, 10).name('Y 轴');
        cameraFolder.add(this.camera.position, 'z', -10, 10).name('Z 轴');
        cameraFolder.open(); // 默认展开摄像机控制面板


        const cameraRotationFolder = this.gui.addFolder('摄像机旋转');
        cameraRotationFolder.add(this.camera.rotation, 'x', -Math.PI, Math.PI).name('X 轴旋转').listen();
        cameraRotationFolder.add(this.camera.rotation, 'y', -Math.PI, Math.PI).name('Y 轴旋转').listen();
        cameraRotationFolder.add(this.camera.rotation, 'z', -Math.PI, Math.PI).name('Z 轴旋转').listen();

        // 现有的设置项
        this.settings = {
            progress: 0,
        };
        this.gui.add(this.settings, "progress", 0, 1, 0.01).name('进度');
    }

    setupResize() {
        window.addEventListener("resize", this.resize.bind(this));
    }

    resize() {
        this.width = this.container.offsetWidth;
        this.height = this.container.offsetHeight;
        this.renderer.setSize(this.width, this.height);
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();
    }

    addObjects() {
        this.material = new THREE.ShaderMaterial({
            extensions: {
                derivatives: "#extension GL_OES_standard_derivatives : enable"
            },
            side: THREE.DoubleSide,
            uniforms: {
                time: {type: "f", value: 0},
                resolution: {type: "v4", value: new THREE.Vector4()},
                uvRate1: {
                    value: new THREE.Vector2(1, 1)
                },
                mouse: {type: "v2", value: new THREE.Vector2()} // 添加 mouse uniform
            },
            vertexShader: vertex,
            fragmentShader: fragment
        });

        let number = 10000;
        this.geometry = new THREE.BufferGeometry();
        this.positions = new Float32Array(number * 3);
        this.randoms = new Float32Array(number * 3);
        this.sizes = new Float32Array(number);

        for (let i = 0; i < number * 3; i += 3) {
            this.positions[i + 0] = (Math.random() - 0.5);
            this.positions[i + 1] = (Math.random() - 0.5);
            this.positions[i + 2] = (Math.random() - 0.5);

            this.randoms[i + 0] = Math.random();
            this.randoms[i + 1] = Math.random();
            this.randoms[i + 2] = Math.random();

            this.sizes[i / 3] = 0.5 + 0.5 * Math.random();
        }
        this.geometry.setAttribute("position", new THREE.BufferAttribute(this.positions, 3));
        this.geometry.setAttribute("aRandom", new THREE.BufferAttribute(this.randoms, 3));
        this.geometry.setAttribute("size", new THREE.BufferAttribute(this.sizes, 1));

        this.plane = new THREE.Points(this.geometry, this.material);
        this.scene.add(this.plane);
    }

    stop() {
        this.isPlaying = false;
    }

    play() {
        if (!this.isPlaying) {
            this.render();
            this.isPlaying = true;
        }
    }

    render() {
        if (!this.isPlaying) return;
        this.time += 0.05;
        this.material.uniforms.time.value = this.time;
        this.material.uniforms.mouse.value = new THREE.Vector2(this.mouse.x, this.mouse.y);

        requestAnimationFrame(this.render.bind(this));
        this.renderer.render(this.scene, this.camera);
    }
}

// new Sketch({
//     dom: document.getElementById("container")
// });